import back_arrow from "../../assets/back_arrow.svg"
import {useNavigate} from "react-router-dom";
import textUtils from "../../utils/TextUtils";
import dateUtils from "../../utils/DateUtils";

const ValuerAmendHeader = (props) => {
    const navigate = useNavigate();

    const savingQueue = props.savingQueue
    const savedTimestamps = props.savedTimestamps
    const erroredSaves = props.erroredSaves

    const address = props.address;

    const valuationId = props.valuationId

    const handleClickBack = () => {
        if (!valuationId) return
        navigate(`/valuer/review/${valuationId}`)
    }

    return (
        <div className="valuer-amend-header-container">
            <div className="valuer-amend-back-button link" onClick={() => handleClickBack()}>
                <img src={back_arrow} alt="Back arrow" />
                <div className="valuer-amend-button-text"> Back </div>
            </div>
            <div className="valuer-amend-address">
                {address}
            </div>
            <div className="valuer-amend-save-container">
                <div className="valuer-amend-saving-text">
                    {savingQueue && savingQueue.length > 0
                        ? "Saving...."
                        : ((erroredSaves && erroredSaves.length > 0)
                            ? "Unable to save. Please check your connection or try again."
                            : ((savedTimestamps && savedTimestamps.length > 0
                                ? "All changes saved at " + dateUtils.display_time(Math.max(...savedTimestamps))
                                : "No changes made")))
                    }
                </div>
                {/*<div className={savingQueue || !savingQueue ? "valuer-amend-save-button disabled" : "valuer-amend-save-button link"}>*/}
                {/*    Save*/}
                {/*</div>*/}
            </div>
        </div>
    )
}

export default ValuerAmendHeader